import { useState } from 'react';
import { ModelBuilderThreadList } from '../components/model-builder/ModelBuilderThreadList';
import { ModelBuilderChat } from '../components/model-builder/ModelBuilderChat';
import { useCompany } from '../contexts/CompanyContext';

export default function ModelBuilderPage() {
  const { selectedCompanies, addCompany, removeCompany } = useCompany();
  const [activeThreadId, setActiveThreadId] = useState(null);
  const [refreshThreads, setRefreshThreads] = useState(0);

  return (
    <div className="flex h-full bg-white" style={{ overscrollBehavior: 'none' }}>
      <ModelBuilderThreadList
        activeThreadId={activeThreadId}
        onSelectThread={setActiveThreadId}
        onNewChat={() => setActiveThreadId(null)}
        refreshKey={refreshThreads}
      />
      <ModelBuilderChat
        threadId={activeThreadId}
        selectedCompanies={selectedCompanies}
        onSelectCompany={addCompany}
        onRemoveCompany={removeCompany}
        onThreadCreated={(tid) => { setActiveThreadId(tid); setRefreshThreads(r => r + 1); }}
      />
    </div>
  );
}
